module.exports = __webpack_public_path__ + "media/components/images/panels/2-b-0dfc58e190c60e26555f8ba3267e2a60.jpeg";